import request from '@/utils/request';

//列表数据
export function getLifeCycleList(values) {
  return request('/lifecycle/queryPage', {
    method: 'POST',
    data: values,
  });
}

//终止
export function terminate(values) {
  return request('/lifecycle/terminate', {
    method: 'POST',
    data: values,
  });
}
